import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { computed, defineComponent, toRefs } from "vue";
export default defineComponent({
  props: {
    /** 图标名称 */
    icon: {
      type: String,
      reuqired: true
    },

    /** 图标名称前缀 */
    iconPrefix: {
      type: String,
      default: "music"
    },

    /** 图标的来源网站, 默认iconfont */
    iconSource: {
      type: String,
      default: "iconfont"
    },

    /** 图标的颜色，默认为黑色 */
    color: {
      type: String,
      default: "#000000"
    },

    /** 图标的背景颜色，默认为白色 */
    bgColor: {
      type: String,
      default: "#fff"
    },

    /** 图标的尺寸，默认14px */
    size: {
      type: Number,
      default: 16
    },

    /** cursor: pointrt  */
    cursor: {
      type: String,
      default: "pointer"
    },

    /** 缩放比例, 默认50% */
    scale: {
      type: Number,
      default: 0.5
    }
  },
  emits: ["click"],
  name: "MusicPlayIcon",
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _toRefs = toRefs(props),
        icon = _toRefs.icon,
        iconPrefix = _toRefs.iconPrefix,
        iconSource = _toRefs.iconSource,
        color = _toRefs.color,
        bgColor = _toRefs.bgColor,
        size = _toRefs.size,
        cursor = _toRefs.cursor,
        scale = _toRefs.scale;
    /** 图标的class */


    var iconClass = computed(function () {
      return "".concat(iconSource.value, " ").concat(iconPrefix.value, "-").concat(icon === null || icon === void 0 ? void 0 : icon.value);
    });
    /** 图标的style */

    var iconStyle = computed(function () {
      return {
        color: color.value,
        backgroundColor: bgColor.value,
        width: "".concat(size.value, "px"),
        height: "".concat(size.value, "px"),
        fontSize: "".concat(size.value * scale.value, "px"),
        cursor: cursor.value
      };
    });
    /** 图标点击事件 */

    var handleClick = function handleClick(e) {
      return emit("click", e);
    };

    return {
      iconClass: iconClass,
      iconStyle: iconStyle,
      handleClick: handleClick
    };
  }
});